import React from 'react'
import { Row, Col, Container } from 'components/Layout'
import { Link } from 'react-router'

import cn from 'classnames'
import s from './Footer.scss'
import sLay from 'styles/modules/layout.scss'

export default props => {
  const { links, children, className, white, showAddToHomeModal, ...otherProps } = props
  return (
    <div>
      <footer className={cn(s.footer, { [s.white]: white }, className)} {...otherProps}>
        <Container>
          <Row className={cn(sLay['layout-row'], sLay['layout-wrap'])}>
            {links.map(section => (
              <Col key={section.title} className={cn(sLay.flex, sLay['flex-xs-33'])}>
                <div className={s.linksTitle}>{section.title}</div>
                {section.items.map(item =>
                  item.to ? (
                    <Link key={item.name} className={s.link} to={item.to}>
                      {item.name}
                    </Link>
                  ) : (
                    <a
                      key={item.name}
                      className={s.link}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.name}
                    </a>
                  )
                )}
              </Col>
            ))}
          </Row>
        </Container>
      </footer>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx